import { useTranslation } from 'react-i18next';
import { createFileRoute } from '@tanstack/react-router';
import { useSuspenseQuery } from '@tanstack/react-query';
import { ErrorComponent } from '@/components/generalError';
import { getConsentFormTemplateQueryOptions } from '@/api/queries/consents';
import { BackButton } from '@/components/ui/backButton';
import { ConsentPdfViewer } from '@/components/consents/pdfRegionSelector/ConsentPdfViewer';
import { routes } from '@/types/routes';

export const Route = createFileRoute('/_app/consents/$templateId')({
  loader: ({ params, context: { queryClient } }) => {
    return queryClient.ensureQueryData(getConsentFormTemplateQueryOptions(params.templateId));
  },
  component: RouteComponent,
  errorComponent: ErrorComponent,
});

function RouteComponent() {
  const { t } = useTranslation();
  const { templateId } = Route.useParams();
  const { data: template } = useSuspenseQuery(getConsentFormTemplateQueryOptions(templateId));

  return (
    <div className="flex flex-col flex-1 h-full">
      <header className="flex flex-col space-y-space-2xs mb-4">
        <BackButton linkLabel={ t('routes.consents') } href={ routes.consents } />
        <h1 className="text-3xl font-semibold">
          { template.name }
          { ' ' }
          { template.version }
        </h1>
      </header>

      <div className="mt-10">
        <ConsentPdfViewer
          file={ { url: template.file.url } }
          metadata={ template.metadata }
          readonly={ true }
        />
      </div>
    </div>
  );
}
